// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBxiKLGDn-PpB5weeTgQxZfjmwqNLN8dgk",
  authDomain: "ran-page.firebaseapp.com",
  projectId: "ran-page",
  storageBucket: "ran-page.firebasestorage.app",
  messagingSenderId: "91375856794",
  appId: "1:91375856794:web:4505b79b52dd3326d0c323",
  measurementId: "G-TECTY52X2X"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
